function getDate() {
  return new Date().Format("yyyy-MM-dd")
}

function getDateStr(value) {
  if (value == null || value == '') {
    return null
  } else {
    return new Date(value).Format("yyyy-MM-dd")
  }
}
function getDateBegin(value) {
  if (value == null || value == '') {
    return null
  } else {
    return new Date(value).Format("yyyy-MM-dd 00:00:00")
  }
}
function getDateEnd(value) {
  if (value == null || value == '') {
    return null
  } else {
    return new Date(value).Format("yyyy-MM-dd 23:59:59")
  }
}


function getDateRangeBegin(value) {
  if (value == null || value[0] == '') {
    return null
  } else {
    return new Date(value[0]).Format("yyyy-MM-dd 00:00:00")
  }
}

function getDateRangeEnd(value) {
  if (value == null || value[1] == '') {
    return null
  } else {
    return new Date(value[1]).Format("yyyy-MM-dd 23:59:59")
  }
}


function getDateTime() {
  return new Date().Format("yyyy-MM-dd HH:mm:ss")
}

export default {
  getDate,
  getDateStr,
  getDateBegin,
  getDateEnd,
  getDateRangeBegin,
  getDateRangeEnd,
  getDateTime
};



// WEBPACK FOOTER //
// ./src/tools/date.js